import React, { useState, useEffect } from 'react';
import '../../../../Customer/Menu/NavBar/navBar.css';
import '../../menus/menuItemcard.css';
import ApiService from '../../../../services/apiService';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getUserId } from '../../../../../Redux/selecters';
import { CounterType } from '../../../../../Enums/config';
import { FaRegEdit } from 'react-icons/fa';
import { ClipLoader } from 'react-spinners';
import { useNavigate } from 'react-router-dom';

const CreateCounter = () => {
  const [Counter, setCounter] = useState();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const { t } = useTranslation();
  const [selectedCounter, setSelectedCounter] = useState();
  const [restaurant, setRestaurant] = useState([]);
  const [branches, setBranches] = useState([]);
  const [terminal, setTerminal] = useState([]);
  const [merchaint, setMerchaint] = useState([]);
  const [loading, setLoader] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [edit, setEdit] = useState(false);
  const apiService = new ApiService();
  let UserId = useSelector(getUserId);
  debugger;
  useEffect(() => {
    GetRestaurant();
    GetCounter();
  }, [searchTerm]);

  const [formData, setFormData] = useState({
    counterName: '',
    ipAddress: '',
    CounterType: '',
    branchId: '',
    terminal: [],
    merchaint: [],
    restaurant: [],
    id: 0,
  });

  const GetRestaurant = async () => {
    try {
      let res = await apiService.get('GET_RESTAURANT');
      // let terRes = await apiService.get('GET_MARCHAINT');
      // let terFiltered = terRes.data.result.filter(res => res?.status == 1);
      let filtered = res.data.result.filter((res) => res?.isActive == true);
      setRestaurant(filtered);
      // setMerchaint(terFiltered);
    } catch (error) {
      console.error('Error fetching Restaurant data:', error);
    }
  };
  const handleRestaurantChange = async (selectedOption) => {
    if (selectedOption) {
      const selectedRestaurant = selectedOption.value;
      setFormData({ ...formData, restaurant: selectedOption });
      setSelectedBranch(null); // Reset branch selection
      try {
        const apiService = new ApiService();
        let param = `?restaurantId=${selectedRestaurant?.id}`;
        let res = await apiService.getApiParamater('GET_BRANCH', param);
        let activeBranches = res.data.result.filter((branch) => branch?.isActive === true);
        setBranches(activeBranches);
      } catch (error) {
        console.error('Error fetching branches:', error);
      }
    } else {
      setFormData({ ...formData, restaurant: '' });
      setBranches([]);
      setSelectedBranch(null);
    }
  };
  const handleBranchChange = (selectedOption) => {
    setSelectedBranch(selectedOption);

    setFormData({ ...formData, branchId: selectedOption?.value });
  };
  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleCreate = async () => {
    if (!formData?.counterName) {
      toast.warning('Enter Counter Name');
    } else if (!formData?.CounterType) {
      toast.warning('Enter Counter Type');
    }
    // else if (!formData?.merchaint?.value?.id) { toast.warning("Select Merchant") }
    // else if (!formData?.terminal) { toast.warning("Select Terminal") }
    else {
      try {
        const datareq = {
          loggedInUserId: UserId.toString(),
          name: formData.counterName,
          type: formData?.CounterType,
          active: true,
          ipAddress: formData?.ipAddress,
          merchantId: formData?.merchaint?.value?.id,
          branch_id: formData?.branchId,
          restaurantId: formData?.restaurant?.value?.id,
          //   terminals: [
          //     {
          //       id: formData?.terminal?.value?.id || '0',
          //       terminalId: formData?.terminal?.value?.terminalId || '0',
          //     },
          //   ],
        };
        const apiService = new ApiService();
        let res = await apiService.post('CREATE_COUNTER', datareq);

        if (res?.data?.statusCode === 201) {
          toast.success(res?.data?.message);
          GetCounter();
          setFormData({
            counterName: '',
            CounterType: '',
            ipAddress: '',
            branchId: '',
            terminal: [],
          });
          setSelectedCounter(null);
          setSelectedBranch(null);
        } else {
          toast.warning(res?.data?.message);
        }
      } catch (error) {
        console.error('Error:', error);
      }
    }
  };
  const handleUpdate = async () => {
    if (!formData?.counterName) {
      toast.warning('Enter Counter Name');
    } else if (!formData?.CounterType) {
      toast.warning('Enter Counter Type');
    }
    // else if (!formData?.merchaint?.value?.id) { toast.warning("Select Merchant") }
    // else if (!formData?.terminal) { toast.warning("Select Terminal") }
    else {
      try {
        const datareq = {
          id: formData?.id,
          loggedInUserId: UserId.toString(),
          name: formData.counterName,
          type: formData?.CounterType,
          ipAddress: formData?.ipAddress,
          active: true,
          merchantId: formData?.merchaint?.value?.id,
          branch_id: formData?.branchId,
          restaurantId: formData?.restaurant?.value?.id,
          //   terminals: [
          //     {
          //       id: formData?.terminal?.value?.id || 0,
          //       terminalId: formData?.terminal?.value?.terminalId || 0,
          //     },
          //   ],
        };
        const apiService = new ApiService();
        let res = await apiService.put('UPDATE_COUNTER', datareq);

        if (res?.data?.statusCode === 201 || res?.data?.statusCode === 200) {
          toast.success(res?.data?.message);
          GetCounter();
          setFormData({
            counterName: '',
            CounterType: '',
            ipAddress: '',
            branchId: '',
            terminal: [],
          });
          setSelectedCounter(null);
          setSelectedBranch(null);
        } else {
          toast.warning(res?.data?.message);
        }
      } catch (error) {
        console.error('Error:', error);
      }
    }
  };
  const handleCounterChange = (selectedOption) => {
    setSelectedCounter(selectedOption);
    setFormData({ ...formData, CounterType: selectedOption?.value });
  };
  const GetCounter = async () => {
    try {
      const apiService = new ApiService();
      // let parameters = `?Name=${searchTerm}`;
      const res = await apiService.get('GET_COUNTERS_MASTER');

      setCounter(res?.data.result);
    } catch (error) {
      console.error('Error fetching Counter data:', error);
    }
  };
  const handleModifierChange = (selectedOptions) => {
    setFormData({ ...formData, terminal: selectedOptions });
  };
  const handleMerchaintChange = (selectedOptions) => {
    setFormData({ ...formData, merchaint: selectedOptions });
    GetTerminal(selectedOptions);
  };
  const GetTerminal = async (selectedOptions) => {
    try {
      const params = new URLSearchParams();
      params.append('MerchantId', selectedOptions?.value?.id);
      const terRes = await apiService.getApiParamater('GET_TERMINAL', `?${params.toString()}`);
      if (terRes?.data?.result?.length >= 1) {
        let terFiltered = terRes?.data?.result.filter((res) => res?.status == 1);
        setTerminal(terFiltered);
      } else {
        toast.warning(`Add terminal in this ${formData?.merchaint?.label}`);
        setTerminal(null);
      }
    } catch (error) {
      console.error('Error fetching Restaurant data:', error);
    }
  };
  const handleSwitchChange = async (payment, newActiveStatus) => {
    try {
      await handleUpdatePayment(payment, newActiveStatus);
    } catch (error) {
      console.error('Error updating Counter status:', error);
    }
  };
  const handleUpdatePayment = async (payment, newActiveStatus) => {
    try {
      const apiService = new ApiService();

      const matchedMerchant = merchaint.find((m) => m.merchantId === payment.merchantId);
      const matchedTerminal = matchedMerchant?.merchantTerminals?.find((t) => t.terminalId === payment.terminalId);
      const catData = {
        id: payment?.counterId,
        active: newActiveStatus,
        terminals: [
          {
            id: matchedTerminal?.id,
            terminalId: matchedTerminal?.terminalId,
          },
        ],
      };

      const res = await apiService.put(`UPDATE_COUNTER`, catData);
      if (res?.data?.statusCode === 200) {
        toast.success(`${payment?.counterName} updated successfully!`);
        GetCounter();
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      console.error('Error updating Counter:', error);
    }
  };
  const handleEdit = (data) => {
    setEdit(true);
    const matchedMerchant = merchaint.find((m) => m.merchantId === data.merchantId);
    const matchedTerminal = matchedMerchant?.merchantTerminals?.find((t) => t.terminalId === data.terminalId);
    const matchedRestaurant = restaurant.find((r) => r.id === data.restaurantId);
    const matchedBranch = branches.find((b) => b.id === data.branchId);

    setSelectedBranch(matchedBranch ? { value: matchedBranch.id, label: matchedBranch.branchName } : null);
    setSelectedCounter(CounterType?.find((ct) => ct.type === data.type)); // For counter type
    debugger;
    setFormData({
      id: data.counterId,
      counterName: data.counterName,
      ipAddress: data.ipAddress,
      branchId: data.branchId,
      restaurant: matchedRestaurant ? { value: matchedRestaurant, label: matchedRestaurant.name } : null,
      terminal: matchedTerminal ? { value: matchedTerminal.terminalId, label: matchedTerminal.name } : null,
      merchaint: matchedMerchant ? { value: matchedMerchant.merchantId, label: matchedMerchant.name } : null,
    });
  };

  return (
    <div className="p-lg-5 container">
      <button className="addItem-btn mb-3" onClick={() => navigate(-1)}>
        ← Back
      </button>
      <div className="row catlist">
        <div className="form-group row mt-4 justify-content-between">
          <div className="col-md-5 col-lg-5">
            <label htmlFor="validationCustom01" className="form-label">
              {t('Company')} {t('name')}
            </label>
            <Select
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={formData?.restaurant}
              onChange={handleRestaurantChange}
              options={restaurant?.map((restaurant) => ({ value: restaurant, label: restaurant.name }))}
            />
            <div className="valid-feedback">Looks good!</div>
          </div>
          <div className="col-md-5">
            <label className="form-label">{t('branch')}</label>
            <Select
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              name="branch"
              options={branches?.map((branch) => ({
                value: branch.id,
                label: branch.branchName,
              }))}
              value={selectedBranch}
              onChange={handleBranchChange}
              // isDisabled={!editMode}
            />
          </div>
        </div>
        <div className="form-group row mt-2 justify-content-between align-content-center">
          <div className="col-md-5">
            <label htmlFor="validationCustomName" className="form-label">
              {t('Counter')} {t('name')}
            </label>
            <input
              type="text"
              className="p-2 form-control"
              id="validationCustomName"
              name="counterName"
              placeholder="Enter name..."
              value={formData.counterName}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="col-md-5">
            <div>
              <label htmlFor="validationCustomCounter" className="form-label">
                {t('Counter')} {t('type')}
              </label>
              <Select
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                    color: state.isFocused ? '#000 ' : '#000',
                    ':hover': {
                      backgroundColor: '#F5F5F5',
                      color: '#000 ',
                    },
                  }),
                }}
                id="Counter"
                value={CounterType ? selectedCounter : ''}
                onChange={handleCounterChange}
                options={CounterType?.map((counter) => ({ value: counter.type, label: counter.value }))}
              />
              <div className="valid-feedback">Looks good!</div>
            </div>
          </div>
        </div>
        <div className="form-group row mt-2 justify-content-between align-content-center">
          <div className="col-md-5">
            <label htmlFor="validationCustomName" className="form-label">
              {t('ip')} {t('address')}
            </label>
            <input
              type="text"
              className="p-2 form-control"
              id="validationAdress"
              name="ipAddress"
              placeholder="Enter Address..."
              value={formData.ipAddress}
              onChange={handleInputChange}
            />
          </div>
          {/* <div className="col-md-5">
                        <label htmlFor="validationCustom15" className="form-label">
                            {t('select')} {t('Merchant')}
                        </label>
                        <Select styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            option: (provided, state) => ({
                                ...provided,
                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                color: state.isFocused ? '#000 ' : '#000',
                                ':hover': {
                                    backgroundColor: '#F5F5F5',
                                    color: '#000 ',
                                },
                            }),
                        }}
                            value={formData.merchaint}
                            onChange={handleMerchaintChange}
                            menuPortalTarget={document.body}
                            menuPlacement="auto"
                            options={merchaint?.map((ter) => ({ value: ter, label: ter.name }))}
                            menuShouldScrollIntoView={false}
                        />
                    </div> */}
        </div>
        <div className="form-group row mt-2 justify-content-between align-content-center">
          {/* <div className="col-md-5">
                        <label htmlFor="validationCustom15" className="form-label">
                            {t('select')} {t('terminal')}
                        </label>
                        <Select
                            options={terminal?.map((ter) => ({ value: ter, label: ter.name }))}
                            value={formData.terminal}
                            onChange={handleModifierChange}
                            placeholder={`${t('select')}  ${t('terminal')}`}
                            className=''
                        />
                    </div> */}
        </div>
        <div className="row justify-content-between mt-4">
          {loading ? (
            <div className="col-lg-2 col-md-2 addItem-btn p-3 mt-4 mb-3 mx-3">
              <ClipLoader loading={loading} size={30} color="#fff" />
            </div>
          ) : (
            <>
              {edit === true ? (
                <div className="col-lg-2 col-md-2 addItem-btn p-3 mt-4 mb-3 mx-3" onClick={() => handleUpdate()}>
                  {t('Update')}
                </div>
              ) : (
                <div className="col-lg-2 col-md-2 addItem-btn p-3 mt-4 mb-3 mx-3" onClick={() => handleCreate()}>
                  {t('save')}
                </div>
              )}
            </>
          )}
        </div>
      </div>

      <div className="pt-4 mt-4">
        <div className="mt-4">
          <div className="catlist mt-5 table-responsive">
            <table className="table table-striped mt-3">
              <thead>
                <tr>
                  <th>
                    {t('counter')} {t('name')}
                  </th>
                  {/* <th>{t('type')}</th> */}
                  <th>
                    {t('ip')} {t('address')}
                  </th>
                  <th>
                    {t('Branch')} {t('Name')}
                  </th>
                  <th>
                    {t('Company')} {t('Name')}
                  </th>

                  {/*    <th>{t('Merchaint')} {t('id')}</th>
                                    <th>{t('terminal')} {t('name')}</th> */}
                  <th>{t('action')}</th>
                </tr>
              </thead>
              <tbody>
                {Counter?.map((methods, index) => (
                  <tr key={index}>
                    <td>{methods.name}</td>
                    {/* <td>{methods.type}</td> */}
                    <td>{methods.ipAddress || '----'}</td>
                    <td>{methods.branchName || '----'}</td>
                    <td>{methods.restaurantName || '----'}</td>
                    {/* <td>{methods.branchId || '----'}</td> */}
                    {/*<td>{methods.merchantId || "----"}</td>
                                        <td>{methods.terminalName || "----"}</td> */}
                    <td>
                      <div className="d-flex gap-3">
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={methods.active}
                            onChange={(e) => handleSwitchChange(methods, e.target.checked)}
                          />
                        </div>
                        <div className="center" onClick={() => handleEdit(methods)}>
                          <FaRegEdit size={25} />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateCounter;
